define(function (require) {
    "use strict";

    var Backbone = require('backbone');

    var STATES = {
        CHECKED: "checked",
        UNCHECKED: "unchecked",
        MIDCHECKED: "midchecked"
    };

    var MODES = {
        BOOLEAN: "boolean",
        TRISTATE: "tristate"
    };

    var CheckboxModel = Backbone.Model.extend({
        defaults : {
            checked : STATES.UNCHECKED,
            mode : MODES.BOOLEAN,
            label : '',
            enabled : true
        }
    });

    CheckboxModel.STATES = STATES;
    CheckboxModel.MODES = MODES;

    return CheckboxModel;
});
